<template>
    <div class="reader">
        <v-container>
            <v-row justify="center">
                <v-col cols="8" md="6">
                    <v-text-field v-model="newTeam" label="New Team Name" clearable></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-btn
                        :disabled="isSaving || isLoading"
                        :loading="isSaving"
                        @click="createTeam"
                        color="secondary"
                        dense
                        >Add Team</v-btn
                    >
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-data-table
                        :headers="headers"
                        :items="teams"
                        :items-per-page="15"
                        class="elevation-1"
                        item-key="id"
                        dense
                        :footer-props="{
                            showFirstLastPage: true,
                            itemsPerPageOptions: [-1, 10, 15, 20, 25],
                            firstIcon: 'mdi-arrow-collapse-left',
                            lastIcon: 'mdi-arrow-collapse-right',
                            prevIcon: 'mdi-minus',
                            nextIcon: 'mdi-plus',
                        }"
                    >
                        <template v-slot:[`item.name`]="props">
                            <v-edit-dialog
                                :return-value.sync="props.item.name"
                                large
                                persistent
                                @save="saveName(props.item)"
                            >
                                <div>{{ props.item.name }}</div>
                                <template v-slot:input>
                                    <div class="mt-4 title">
                                        Update Name
                                    </div>
                                    <v-text-field
                                        v-model="props.item.name"
                                        label="Edit"
                                        single-line
                                        counter
                                    ></v-text-field>
                                </template>
                            </v-edit-dialog>
                        </template>
                        <template v-slot:[`item.isDisabled`]="{ item }">
                            <div class="d-flex justify-center justify-md-end ma-2">
                                <v-simple-checkbox v-model="item.isDisabled" dense disabled></v-simple-checkbox>
                                <v-spacer></v-spacer>
                                <v-btn
                                    small
                                    :disabled="isLoading || isSaving"
                                    :color="item.isDisabled ? `success` : `error`"
                                    @click="toggleActive(item)"
                                >
                                    {{ item.isDisabled ? `Enable` : `Disable` }}
                                </v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import api from '@/api'
export default {
    name: 'TeamsManager',
    data() {
        return {
            isLoading: false,
            isSaving: false,
            teams: [],
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
                { text: 'Is Disabled', value: 'isDisabled' },
            ],
            newTeam: '',
        }
    },
    mounted() {
        this.getTeams()
    },
    methods: {
        getTeams() {
            this.isLoading = true
            api.get('/team/getAll')
                .then(res => {
                    this.teams = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        createTeam() {
            this.isSaving = true
            let team = {
                name: this.newTeam,
            }
            api.post(`team/create`, team)
                .then(res => {
                    this.teams.push(res)
                    this.newTeam = ''
                })
                .finally(() => {
                    this.isSaving = false
                })
        },
        toggleActive(team) {
            this.isSaving = true
            api.post(`team/${team.isDisabled ? 'enable' : 'disable'}Team/${team.id}`)
                .then(() => {
                    team.isDisabled = !team.isDisabled
                })
                .finally(() => {
                    this.isSaving = false
                })
        },
        saveName(team) {
            this.isSaving = true
            api.post(`team/updateName/`, team)
                .then(() => {
                    this.showSnackbar('success', `${team.name} Team name update`)
                })
                .finally(() => {
                    this.isSaving = false
                })
        },
    },
}
</script>
